export const createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
}

export const convertTime12to24 = (time12h) => {
  if(!time12h || (time12h.toLowerCase().indexOf('am') === -1 && time12h.toLowerCase().indexOf('pm') === -1) ) {
    return time12h
  }

  const modifier = time12h.toLowerCase().indexOf('am') === -1 ? 'PM' : 'AM';

  const time = time12h.replace(/[^\d:]/gmi, '')

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours.toString().padStart(2,'0')}:${minutes}`;
}

export const convertTime24To12 = (time24h) => {
  // Check correct time format and split into components
  time24h = time24h.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time24h];

  if (time24h.length > 1) { // If time format correct
    time24h = time24h.slice(1); // Remove full string match value
    time24h[5] = +time24h[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time24h[0] = +time24h[0] % 12 || 12; // Adjust hours
    time24h[0] = time24h[0].toString().padStart(2,'0')
  }

  return time24h.join(''); // return adjusted time or original string
}

export const getTimeObjWithOffset = (dateObj, timeZoneOffset) => {
  return new Date(dateObj.getTime() + (timeZoneOffset + dateObj.getTimezoneOffset()) * 1000 * 60)
}


